module.exports = __webpack_public_path__ + "assets/img/1w.518127a4.png";